class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);

/* WOLF BROS – choose which cart items go to checkout.
   Unticked items are set aside (saved in this browser) right before checkout and are put back
   into the cart the next time the shopper opens any page of the store. */
(function () {
  if (window.__wbCartSelect) return;
  window.__wbCartSelect = true;
  var KEY = 'wbHeldCartItems';
  var MAX_AGE = 7 * 24 * 3600 * 1000;
  var unselected = {};
  var cartData = null;
  var passThrough = false;

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || null; } catch (e) { return null; }
  }
  function save(v) {
    try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
  }
  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function money(cents) {
    return 'LE ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }
  function css() {
    if (document.getElementById('wb-sel-css')) return;
    var s = document.createElement('style');
    s.id = 'wb-sel-css';
    s.textContent =
      '.cart-item__media,.cart-item__image-container{position:relative!important}' +
      'input.wb-sel{position:absolute;top:6px;left:6px;z-index:3;box-sizing:border-box;width:26px!important;height:26px!important;min-width:26px!important;max-width:none!important;padding:0!important;margin:0!important;flex:none;cursor:pointer;appearance:none;-webkit-appearance:none;border-radius:50%;border:2px solid rgba(var(--color-foreground),.7);background:rgba(var(--color-background),.85);display:grid!important;place-items:center;box-shadow:0 2px 6px rgba(0,0,0,.35)}' +
      'input.wb-sel:checked{background:rgb(var(--color-button));border-color:rgb(var(--color-button))}' +
      'input.wb-sel:checked::after{content:"";width:6px;height:11px;margin-top:-2px;border:solid rgb(var(--color-button-text));border-width:0 2.5px 2.5px 0;transform:rotate(45deg)}' +
      '.cart-item.wb-off .cart-item__image-container img,.cart-item.wb-off .cart-item__details,.cart-item.wb-off .cart-item__totals{opacity:.4}' +
      '.wb-selbar{display:flex;align-items:center;justify-content:space-between;gap:12px;flex-wrap:wrap;margin:0 0 12px;padding:12px 14px;border-radius:12px;background:rgba(var(--color-foreground),.05);border:1px solid rgba(var(--color-foreground),.1);font-size:13px}' +
      '.wb-selbar label{display:flex;align-items:center;gap:10px;cursor:pointer;font-weight:700}' +
      '.wb-selbar input.wb-sel{position:static;box-shadow:none}' +
      '.wb-selbar small{opacity:.65}' +
      '.wb-selnote{margin:12px 0;padding:10px 14px;border-radius:10px;font-size:13px;line-height:1.4;text-align:left;background:rgba(var(--color-button),.12);border:1px solid rgba(var(--color-button),.45)}' +
      '.wb-selnote b{color:rgb(var(--color-button))}' +
      '.wb-held{position:fixed;left:12px;right:12px;bottom:16px;z-index:2147482000;max-width:420px;margin:0 auto;display:flex;align-items:center;gap:12px;padding:12px 14px;border-radius:14px;background:rgb(var(--color-background));color:rgb(var(--color-foreground));border:1px solid rgba(var(--color-foreground),.15);box-shadow:0 14px 40px rgba(0,0,0,.45);font-size:13px}' +
      '.wb-held button{margin-left:auto;flex-shrink:0;height:36px;padding:0 14px;border-radius:9px;border:0;cursor:pointer;font:inherit;font-weight:800;background:rgb(var(--color-button));color:rgb(var(--color-button-text))}';
    document.head.appendChild(s);
  }

  function notice(text, btnText, onClick, ms) {
    css();
    var old = document.querySelector('.wb-held');
    if (old) old.remove();
    var el = document.createElement('div');
    el.className = 'wb-held';
    el.setAttribute('role', 'status');
    el.innerHTML = '<span>' + text + '</span>' + (btnText ? '<button type="button">' + btnText + '</button>' : '');
    document.body.appendChild(el);
    if (btnText) el.querySelector('button').addEventListener('click', function () { onClick(el); });
    if (ms) setTimeout(function () { el.remove(); }, ms);
    return el;
  }
  function refreshBubble() {
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) {
      var el = document.getElementById('cart-icon-bubble');
      if (!el || !s['cart-icon-bubble']) return;
      var d = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (d) el.innerHTML = d.innerHTML;
    }).catch(function () {});
  }
  function restore(force) {
    var h = load();
    if (!h || !h.items || !h.items.length) return;
    if (Date.now() - (h.ts || 0) > MAX_AGE) return clear();
    if (!force && Date.now() - (h.ts || 0) < 3000) return;
    clear();
    post('/cart/add.js', { items: h.items }).then(function (res) {
      if (res && res.status) {
        return h.items.reduce(function (p, it) {
          return p.then(function () { return post('/cart/add.js', { items: [it] }).catch(function () {}); });
        }, Promise.resolve());
      }
    }).then(function () {
      if (isCartPage()) return location.reload();
      refreshBubble();
      var n = h.items.reduce(function (a, i) { return a + (i.quantity || 1); }, 0);
      notice(n + (n === 1 ? ' item you set aside is' : ' items you set aside are') + ' back in your cart.', null, null, 5000);
    });
  }

  function rows() {
    return Array.prototype.slice.call(document.querySelectorAll('#main-cart-items tr.cart-item[id^="CartItem-"]'));
  }
  function itemFor(row) {
    if (!cartData) return null;
    var i = parseInt(row.id.replace('CartItem-', ''), 10) - 1;
    return cartData.items[i] || null;
  }
  function paint() {
    if (!cartData) return;
    css();
    var total = 0, count = 0, all = cartData.items.length;
    cartData.items.forEach(function (it) {
      if (!unselected[it.key]) { total += it.final_line_price; count++; }
    });
    rows().forEach(function (row) {
      var it = itemFor(row);
      var media = row.querySelector('.cart-item__image-container') || row.querySelector('.cart-item__media');
      if (!it || !media) return;
      var cb = media.querySelector('.wb-sel');
      if (!cb) {
        cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.className = 'wb-sel';
        cb.setAttribute('aria-label', 'Include in checkout');
        cb.addEventListener('change', function (e) {
          e.stopPropagation(); // keep the theme's quantity handler out of this
          var cur = itemFor(row);
          if (!cur) return;
          if (cb.checked) delete unselected[cur.key]; else unselected[cur.key] = true;
          paint();
        });
        media.appendChild(cb);
      }
      cb.checked = !unselected[it.key];
      row.classList.toggle('wb-off', !cb.checked);
    });
    var wrap = document.getElementById('main-cart-items');
    var bar = document.querySelector('.wb-selbar');
    if (all > 1 && wrap) {
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'wb-selbar';
        bar.innerHTML = '<label><input type="checkbox" class="wb-sel wb-sel-all"> <span>Select all</span></label><small>Tick the items you want to check out now. The rest stay in your cart.</small>';
        bar.querySelector('.wb-sel-all').addEventListener('change', function (e) {
          e.stopPropagation();
          unselected = {};
          if (!e.target.checked) cartData.items.forEach(function (it) { unselected[it.key] = true; });
          paint();
        });
        wrap.parentNode.insertBefore(bar, wrap);
      }
      bar.querySelector('.wb-sel-all').checked = count === all;
    } else if (bar) bar.remove();

    var totals = document.querySelector('#main-cart-footer .totals');
    var note = document.querySelector('.wb-selnote');
    if (totals && count < all) {
      if (!note || note.previousElementSibling !== totals) {
        if (note) note.remove();
        note = document.createElement('p');
        note.className = 'wb-selnote';
        totals.after(note);
      }
      note.innerHTML = count
        ? 'Checking out <b>' + count + ' of ' + all + '</b> items · <b>' + money(total) + '</b><br>The other ' + (all - count) + ' will stay in your cart.'
        : 'Tick at least one item to check out.';
    } else if (note) note.remove();
    document.querySelectorAll('#main-cart-footer .cart__checkout-button, #main-cart-footer .oak-checkout-button').forEach(function (b) {
      b.style.opacity = count === 0 ? '.4' : '';
      b.style.pointerEvents = count === 0 ? 'none' : '';
    });
  }
  function sync() {
    return getCart().then(function (c) {
      cartData = c;
      var keys = {};
      c.items.forEach(function (it) { keys[it.key] = 1; });
      Object.keys(unselected).forEach(function (k) { if (!keys[k]) delete unselected[k]; });
      paint();
    });
  }
  function hold() {
    return getCart().then(function (c) {
      var off = c.items.filter(function (it) { return unselected[it.key]; });
      if (!off.length) return;
      var h = load() || { items: [] };
      off.forEach(function (it) {
        var line = { id: it.variant_id, quantity: it.quantity };
        if (it.properties && Object.keys(it.properties).length) line.properties = it.properties;
        if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) line.selling_plan = it.selling_plan_allocation.selling_plan.id;
        h.items.push(line);
      });
      h.ts = Date.now();
      save(h);
      var updates = {};
      off.forEach(function (it) { updates[it.key] = 0; });
      unselected = {};
      return post('/cart/update.js', { updates: updates });
    });
  }
  document.addEventListener('click', function (e) {
    if (passThrough || !isCartPage() || !Object.keys(unselected).length) return;
    var t = e.target.closest && e.target.closest('[name="checkout"], .cart__checkout-button, .oak-checkout-button, a[href*="/checkout"]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    hold().then(function () {
      if (t.matches('[name="checkout"], .cart__checkout-button')) {
        location.href = '/checkout';
        return;
      }
      passThrough = true;
      t.click();
      passThrough = false;
      setTimeout(function () {
        var h = load();
        if (h && h.items && h.items.length && document.visibilityState === 'visible' && isCartPage()) {
          notice('Some items were set aside for this checkout.', 'Put them back', function () { restore(true); });
        }
      }, 2500);
    });
  }, true);

  function initCartPage() {
    if (!isCartPage()) return;
    sync();
    var box = document.getElementById('main-cart-items');
    var timer;
    new MutationObserver(function (m) {
      var ours = m.every(function (r) {
        return Array.prototype.every.call(r.addedNodes, function (n) { return n.nodeType === 1 && n.classList.contains('wb-sel'); }) && r.removedNodes.length === 0;
      });
      if (ours) return;
      clearTimeout(timer);
      timer = setTimeout(sync, 150);
    }).observe(box, { childList: true, subtree: true });
  }

  function init() {
    restore(false);
    initCartPage();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) restore(true); });
})();